import { updateField } from "vuex-map-fields";
import Vue from "vue";

const SET_ATTACHABLES = (state, { categoryId, attachables }) => {
  state.attachables = { ...state.attachables, [categoryId]: attachables };
};
const SET_PAGINATIONS = (state, { categoryId, pagination }) => {
  state.paginations[categoryId] = pagination;
};
const SET_CAN_PUBLISH_DOCUMENTS = (state, value) => {
  state.canPublishDocuments = value;
};
const SET_HAS_ATTACHABLE_TYPE = (state, value) => {
  state.hasAttachableType = value;
};
const SET_HAS_ATTACHABLE_ID = (state, value) => {
  state.hasAttachableId = value;
};

const SET_SHOW_MOVE_MODAL = (state, showMoveModal) => {
  state.showMoveModal = showMoveModal;
};
const SET_SHOW_DELETE_MODAL = (state, showDeleteModal) => {
  state.showDeleteModal = showDeleteModal;
};
const SET_SHOW_COPY_MODAL = (state, showCopyModal) => {
  state.showCopyModal = showCopyModal;
};
const SET_SELECTED_ATTACHABLES = (state, { attachables, id }) => {
  state.selectedAttachables = { ...state.selectedAttachables, [id]: attachables };
};
const SET_ACTIVE_CATEGORY_ID = (state, id) => {
  state.activeCategoryId = id;
};
const SET_IS_INSTANCE = (state, value) => {
  state.isInstance = value;
};
const SET_CATEGORY = (state, value) => {
  state.category = value;
};
const SET_CUSTOMER_ID = (state, id) => {
  state.customerId = id;
};

const SET_TABLE_ROWS = (state, rows) => {
  state.tableRows = rows;
};
const SET_NOTE_COUNT = (state, count) => {
  state.noteCount = count;
};

const SET_ATTACHABLE_CATEGORIES = (state, categories) => {
  state.attachableCategories = categories;
};
const SET_LOADED = (state, loaded) => {
  state.loaded = loaded;
};

const DELETE_ATTACHABLE = (state, attachableToDelete) => {
  const idx = state.attachables.findIndex((attachable) => attachable.id === attachableToDelete.id);
  state.attachables.splice(idx, 1);
};

const UPDATE_CATEGORY = (state, newCategory) => {
  const newCategoryIndex = state.attachableCategories
    .findIndex((category) => newCategory.name === category.name);
  Vue.set(state.attachableCategories, newCategoryIndex, newCategory);
};

const SET_ACTIVE_ATTACHABLE_CATEGORY_NAME = (state, name) => {
  state.activeAttachableCategoryName = name;
};
const SET_SHOW_UPLOAD_MODAL = (state, uploadModal) => {
  state.showUploadModal = uploadModal;
};
const SET_LOADING_CATEGORIES = (state, loading) => {
  state.loadingCategories = loading;
};

const SET_EDITING_ATTACHABLE_WITH_ID = (state, id) => {
  state.editingAttachableWithId = id;
};
const UPDATE_ATTACHABLE = (state, { attachable }) => {
  const updateAtIndex = state.attachables[attachable.attachable_category_hashed_id]?.findIndex(
    (oldAttachable) => oldAttachable.id === attachable.id,
  );
  if (updateAtIndex === -1) return;
  const clone = { ...state.attachables };
  if (!(attachable.attachable_category_hashed_id in clone)) return;
  clone[attachable.attachable_category_hashed_id][updateAtIndex] = attachable;
  state.attachables = clone;
};
const DELETE_ATTACHABLE_BY_ID = (state, { id, category }) => {
  const deleteAtIndex = state.attachables[category]?.findIndex(
    (attachable) => attachable.id === id,
  );
  if (deleteAtIndex === -1) return;
  const clone = [...state.attachables[category]];
  clone.splice(deleteAtIndex, 1);
  state.attachables = { ...state.attachables, [category]: clone };
};

export default {
  SET_SHOW_UPLOAD_MODAL,
  DELETE_ATTACHABLE_BY_ID,
  UPDATE_CATEGORY,
  SET_LOADED,
  SET_TABLE_ROWS,
  SET_CUSTOMER_ID,
  SET_IS_INSTANCE,
  SET_CATEGORY,
  SET_ATTACHABLES,
  SET_PAGINATIONS,
  SET_ATTACHABLE_CATEGORIES,
  UPDATE_ATTACHABLE,
  SET_HAS_ATTACHABLE_ID,
  SET_SELECTED_ATTACHABLES,
  SET_NOTE_COUNT,
  SET_ACTIVE_ATTACHABLE_CATEGORY_NAME,
  SET_CAN_PUBLISH_DOCUMENTS,
  SET_HAS_ATTACHABLE_TYPE,
  SET_SHOW_DELETE_MODAL,
  SET_EDITING_ATTACHABLE_WITH_ID,
  SET_SHOW_COPY_MODAL,
  SET_SHOW_MOVE_MODAL,
  SET_ACTIVE_CATEGORY_ID,
  SET_LOADING_CATEGORIES,
  DELETE_ATTACHABLE,
  updateField,
};
